import React from 'react';
import MemberOnly from 'components/Promotions/InnerPage/MemberOnly';
import ActivityInfo from 'components/Promotions/InnerPage/ActivityInfo';
import WinningAnnouncement from 'components/Promotions/InnerPage/WinningAnnouncement';
import Schemes from 'components/Promotions/InnerPage/Schemes';
import ActivityNotes from 'components/Promotions/InnerPage/ActivityNotes';
import PageNavControls from 'components/PageNavControls';
import { IProps, IState } from './types';
import { PromotionInfoContent } from 'bff/models/promotion';
import commonService from 'utils/commonService';
import promotionListService from 'bff/services/promotionListService';
import { PromotionInnerType } from 'constants/enums/promotionInnerType.enum';
import ActivityFlow from 'components/Promotions/InnerPage/ActivityFlow';
import { RouterSettings } from 'constants/models/routerSettings';
// import moment from 'moment';
import moment from 'moment-timezone';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { RootReducersState } from 'redux/reducers';
import { Dispatch } from 'redux';
import { AddFavoriteItem } from 'bff/models/member';
import { connect } from 'react-redux';
import { addFavoriteItem, removeFavoriteItem, unloginAddItem } from 'redux/actions/components/myFavorite.action';
import PromotionTypeDefines from 'constants/models/promotionTypeDefines';
import { PromotionSectionType } from 'constants/enums/promotionType.enum';

class PromotionsInnerPage extends React.Component <IProps, IState> {
  componentDidMount () {
    // 頁面初始取得傳入的活動公告內容
    if (!storageService.getItem(storageKeys.PromotionDetail)) {
      this.props.history.goBack();
      return;
    }

    let prePromotionTitle = PromotionTypeDefines[PromotionSectionType.Promotion];
    if (this.props.history.location.state) {
      const { promotionType } : any = this.props.history.location.state;
      if (promotionType) {
        prePromotionTitle = PromotionTypeDefines[promotionType as PromotionSectionType];
      }
    }

    const promotionInfo = JSON.parse(storageService.getItem(storageKeys.PromotionDetail)) as PromotionInfoContent;

    this.setState({ promotionInfo: promotionInfo, prePromotionTitle: prePromotionTitle });
  }

  componentDidUpdate () {

  }

  componentWillUnmount () {
    // 頁面關閉，清除紀錄的 得獎公告編號，暫存明細資料
    storageService.removeItem(storageKeys.PromotionDetail);
    storageService.removeItem(storageKeys.PrizeWinnerSn);
    storageService.setItem(storageKeys.PromotionDetail, JSON.stringify(this.state.promotionInfo));

    // 頁面關閉更新暫存的優惠列表資訊，設定使用區塊為對應區塊
    if (storageService.getItem(storageKeys.TempInfo)) {
      let tempInfo = JSON.parse(storageService.getItem(storageKeys.TempInfo));
      storageService.removeItem(storageKeys.TempInfo);

      tempInfo = {
        ...tempInfo,
        activeTab: PromotionSectionType.Promotion
      };

      storageService.setItem(storageKeys.TempInfo, JSON.stringify(tempInfo));
    }
  }

  render () {
    /**
   * @description 點選上下一則的事件
  */
    const handleNextPrevClick = async (sn: number) => {
      if (!sn) return;

      const promoInfo = await promotionListService.fetchPromotion(sn);
      if (!promoInfo) return;
      storageService.removeItem(storageKeys.PromotionDetail);
      storageService.setItem(storageKeys.PromotionDetail, JSON.stringify(promoInfo));
      this.setState({ promotionInfo: promoInfo });
      // 內容資料有更動，移至畫面上方
      commonService.scrollToTop();
    };

    /**
   * @description 根據不同 Type 設定不同樣式
  */
    const handleSetClassName = (promotionInfo: PromotionInfoContent) => {
      let className = 'promotions-inner-page';

      switch (promotionInfo.INFO_TPL_TYPE) {
        case PromotionInnerType.A:
          className = `${className} promotions-inner-page-a`;
          break;
        case PromotionInnerType.B:
          className = `${className} promotions-inner-page-b`;
          break;
        case PromotionInnerType.C:
          className = `${className} promotions-inner-page-c`;
          break;
      }

      return className;
    };

    /**
   * @description 建立活動資訊區塊
  */
    const handleCreateActivityInfoArea = (promotionInfo: PromotionInfoContent) => {
      let innerPageAd;
      let activity;
      switch (promotionInfo.INFO_TPL_TYPE) {
        case PromotionInnerType.A:
        /* 活動資訊 */
          activity = (
            <ActivityInfo
              EVENT_DESC={promotionInfo.EVENT_DESC}
              EVENT_DRAW_PERIOD={promotionInfo.EVENT_DRAW_PERIOD}
              EVENT_PRIZE={promotionInfo.EVENT_PRIZE}
            />
          );
          break;
        case PromotionInnerType.B:
        /* 活動流程 */
          activity = <ActivityFlow EVENT_FLOW={promotionInfo.EVENT_FLOW} />;
          break;
        case PromotionInnerType.C:
        /* 活動資訊 */
          activity = (
            <ActivityInfo
              EVENT_DESC={promotionInfo.EVENT_DESC}
              EVENT_DRAW_PERIOD={promotionInfo.EVENT_DRAW_PERIOD}
              EVENT_PRIZE={promotionInfo.EVENT_PRIZE}
            />
          );
          break;
      }

      switch (promotionInfo.PROD_TPL_TYPE) {
        case PromotionInnerType.A:
          innerPageAd = (
            <MemberOnly.InnerPageAAds
              imageUrls={promotionInfo.EVENT_IMAGES}
            />
          );
          break;
        case PromotionInnerType.B:
          innerPageAd = (
            <MemberOnly.InnerPageBAds
              imgUrls={promotionInfo.EVENT_IMAGES}
            />
          );
          break;
        case PromotionInnerType.C:
          innerPageAd = (
            <MemberOnly.InnerPageCAds
              imgUrls={promotionInfo.EVENT_IMAGES}
            />
          );
          break;
      }

      return (
        <>
          {/* 會員專屬好康 */}
          <MemberOnly>
            <MemberOnly.Head
              activityDate={`${moment(promotionInfo.START_DATE).format('YYYY/MM/DD')} ~ ${moment(promotionInfo.END_DATE).format('YYYY/MM/DD')}`}
              title={promotionInfo.TITLE}
              subTitle={promotionInfo.SUBTITLE}
              leftImgUrl={promotionInfo.LOGO_1}
              rightImgUrl={promotionInfo.LOGO_2}
            />
            {innerPageAd}
          </MemberOnly>
          {/* 活動資訊 */}
          {activity}
        </>
      );
    };

    /**
   * @description 建立商品列表區塊
  */
    const handleCreateSchemes = (promotionInfo: PromotionInfoContent) => {
      switch (promotionInfo.PROD_TPL_TYPE) {
        case PromotionInnerType.A:
          return (
            <Schemes>
              <Schemes.InnerPageASchemes EVENT_PROD_LIST={promotionInfo.EVENT_PROD_LIST} />
            </Schemes>
          );
        case PromotionInnerType.B:
          return (
            <Schemes>
              <Schemes.InnerPageBSchemes
                EVENT_PROD_LIST={promotionInfo.EVENT_PROD_LIST}
                onAddFavoriteItem={this.props.onAddFavoriteItem}
                onRemoveFavoriteItem={this.props.onRemoveFavoriteItem}
                myFavoriteList={this.props.myFavoriteList}
                unloginAddItem={this.props.unloginAddItem}
              />
            </Schemes>
          );
        case PromotionInnerType.C:
          return (
            <Schemes>
              <Schemes.InnerPageCSchemes
                onAddFavoriteItem={this.props.onAddFavoriteItem}
                onRemoveFavoriteItem={this.props.onRemoveFavoriteItem}
                myFavoriteList={this.props.myFavoriteList}
                unloginAddItem={this.props.unloginAddItem}
                EVENT_PROD_LIST={promotionInfo.EVENT_PROD_LIST}
              />
            </Schemes>
          );
      }
    };

    return this.state && this.state.promotionInfo && (
      <div className={handleSetClassName(this.state.promotionInfo)}>
        {handleCreateActivityInfoArea(this.state.promotionInfo)}
        {/* 得獎公告 */}
        <WinningAnnouncement prizeWinnerSn={this.state.promotionInfo.PRIZE_RESULT_SN && this.state.promotionInfo.PRIZE_RESULT_SN.length > 0 ? Number(this.state.promotionInfo.PRIZE_RESULT_SN[0]) : 0} />
        {/* 方案 */}
        {handleCreateSchemes(this.state.promotionInfo)}
        {/* 活動注意事項 */}
        <ActivityNotes notes={this.state.promotionInfo.NOTE} />
        {/* 頁面導航控制項 */}
        <PageNavControls
          prevBtnLink="/"
          onPrevClick={() => handleNextPrevClick(this.state.promotionInfo?.PREV_SN || 0)}
          nextBtnLink="/"
          onNextClick={() => handleNextPrevClick(this.state.promotionInfo?.NEXT_SN || 0)}
          navBtnLink={RouterSettings.Promotions.List}
          navBtnText={`回${this.state.prePromotionTitle}頁`}
          prevSN={this.state.promotionInfo.PREV_SN}
          nextSN={this.state.promotionInfo.NEXT_SN}
        />
      </div>
    );
  }
};

const mapStateToProps = (state: RootReducersState) => {
  return {
    myFavoriteList: state.myFavorite.myFavoriteList
  };
};

const mapDisatchToProps = (dispatch: Dispatch) => {
  return {
    onAddFavoriteItem: (item: AddFavoriteItem) => dispatch(addFavoriteItem(item)),
    onRemoveFavoriteItem: (sn: any) => dispatch(removeFavoriteItem(sn)),
    unloginAddItem: (insTypeId: string, prodId: string, planId: string) => dispatch(unloginAddItem(insTypeId, prodId, planId))
  };
};

export default connect(mapStateToProps, mapDisatchToProps)(PromotionsInnerPage);
